<script lang="ts">
  import NavItem from "$routes/(microsites)/gpu-glossary/_components/NavItem.svelte";
  import type { Page } from "$routes/(microsites)/gpu-glossary/_lib/gpu-glossary";
  import { themeStore } from "$routes/(microsites)/gpu-glossary/_lib/gpu-glossary";
  import SignUpButton from "./SignUpButton.svelte";
  import ThemeOptions from "./ThemeOptions.svelte";

  export let contents: Page[];
  export let showAdditionalControls = true;
</script>

<div class="overflow-y-scroll border-r-0 py-4">
  {#if showAdditionalControls}
    <div class="glossary-font-secondary mx-4 mb-4 w-fit">
      <SignUpButton />
    </div>
    <div class="mb-4 ml-4 text-lg font-medium sm:mb-7">THEME</div>
    <div
      class="glossary-font-secondary mb-7 ml-4 flex flex-col items-start gap-y-2"
    >
      <ThemeOptions />
    </div>
  {/if}
  <div class="mb-4 ml-4 text-lg font-medium">TABLE OF CONTENTS</div>
  <div class="flex flex-col gap-y-2" style:color={$themeStore.primary[80]}>
    {#each contents as section}
      <NavItem {section} />
    {/each}
  </div>
</div>
